import React, { useEffect } from "react";

//import Scss
import "assets/scss/themes.scss";

//imoprt Route
import Route from "Routes/Index";

import { useDispatch } from "react-redux";
import { loginSuccess } from "slices/auth/login/reducer";
import fakeBackend from "./helpers/AuthType/fakeBackend";
// import { ToastContainer } from "react-toastify";

// Activating fake backend
fakeBackend();

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const App = () => {
  const dispatch = useDispatch<any>();
  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const parsedUser = JSON.parse(authUser);
      dispatch(loginSuccess(parsedUser)); // Rehydrate user into Redux
    }
  }, []);
  return (
    <React.Fragment>
      <Route />
      {/* <ToastContainer position="top-right" autoClose={2000} /> */}
    </React.Fragment>
  );
};

export default App;
